import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTenantBids } from 'app/entities/tenant-bids/tenant-bids.reducer';
import { createEntity, getEntity, reset, updateEntity } from './tenant-bid-item.reducer';

export const TenantBidItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const tenantBids = useAppSelector(state => state.tenantBids.entities);
  const tenantBidItemEntity = useAppSelector(state => state.tenantBidItem.entity);
  const loading = useAppSelector(state => state.tenantBidItem.loading);
  const updating = useAppSelector(state => state.tenantBidItem.updating);
  const updateSuccess = useAppSelector(state => state.tenantBidItem.updateSuccess);

  const handleClose = () => {
    navigate(`/tenant-bid-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTenantBids({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.qty !== undefined && typeof values.qty !== 'number') {
      values.qty = Number(values.qty);
    }
    if (values.chargedMrp !== undefined && typeof values.chargedMrp !== 'number') {
      values.chargedMrp = Number(values.chargedMrp);
    }
    if (values.discount !== undefined && typeof values.discount !== 'number') {
      values.discount = Number(values.discount);
    }
    if (values.manufacDate !== undefined && typeof values.manufacDate !== 'number') {
      values.manufacDate = Number(values.manufacDate);
    }
    if (values.expDate !== undefined && typeof values.expDate !== 'number') {
      values.expDate = Number(values.expDate);
    }
    if (values.cgst !== undefined && typeof values.cgst !== 'number') {
      values.cgst = Number(values.cgst);
    }
    if (values.sgst !== undefined && typeof values.sgst !== 'number') {
      values.sgst = Number(values.sgst);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...tenantBidItemEntity,
      ...values,
      bid: tenantBids.find(it => it.id.toString() === values.bid?.toString()),
      tenantBids: tenantBids.find(it => it.id.toString() === values.tenantBids?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...tenantBidItemEntity,
          bid: tenantBidItemEntity?.bid?.id,
          tenantBids: tenantBidItemEntity?.tenantBids?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.tenantBidItem.home.createOrEditLabel" data-cy="TenantBidItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.tenantBidItem.home.createOrEditLabel">Create or edit a TenantBidItem</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tenant-bid-item-id"
                  label={translate('tinyMedicRestApp.tenantBidItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidItem.stockId')}
                id="tenant-bid-item-stockId"
                name="stockId"
                data-cy="stockId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidItem.name')}
                id="tenant-bid-item-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidItem.qty')}
                id="tenant-bid-item-qty"
                name="qty"
                data-cy="qty"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidItem.chargedMrp')}
                id="tenant-bid-item-chargedMrp"
                name="chargedMrp"
                data-cy="chargedMrp"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidItem.discount')}
                id="tenant-bid-item-discount"
                name="discount"
                data-cy="discount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidItem.manufacDate')}
                id="tenant-bid-item-manufacDate"
                name="manufacDate"
                data-cy="manufacDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidItem.expDate')}
                id="tenant-bid-item-expDate"
                name="expDate"
                data-cy="expDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidItem.cgst')}
                id="tenant-bid-item-cgst"
                name="cgst"
                data-cy="cgst"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidItem.sgst')}
                id="tenant-bid-item-sgst"
                name="sgst"
                data-cy="sgst"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidItem.active')}
                id="tenant-bid-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidItem.cursor')}
                id="tenant-bid-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidItem.lastUpdated')}
                id="tenant-bid-item-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidItem.microSec')}
                id="tenant-bid-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidItem.timestampEntry')}
                id="tenant-bid-item-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="tenant-bid-item-bid"
                name="bid"
                data-cy="bid"
                label={translate('tinyMedicRestApp.tenantBidItem.bid')}
                type="select"
              >
                <option value="" key="0" />
                {tenantBids
                  ? tenantBids.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tenant-bid-item-tenantBids"
                name="tenantBids"
                data-cy="tenantBids"
                label={translate('tinyMedicRestApp.tenantBidItem.tenantBids')}
                type="select"
              >
                <option value="" key="0" />
                {tenantBids
                  ? tenantBids.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/tenant-bid-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TenantBidItemUpdate;
